import { withTranslation } from "react-i18next";
import withRouter from "../../../components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import { Badge, Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { useEffect, useRef, useState } from "react";
import { createSelector } from "reselect";
import { useDispatch, useSelector } from "react-redux";
import {
  loadPaySlipHistory as onLoadPaySlipHistory,
  loadAllPaySlipHistory as onLoadAllPaySlipHistory,
  runPayRoll,
  validatePayslips,
  rejectPayslips,
} from "../../../slice/thunks";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import PrintHeader from "../../../components/Global/PrintHeader";

const PayMaster = (props) => {
    const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const month = queryParams.get("month");
  const year = queryParams.get("year");
  const [currentMonth, setCurrentMonth] = useState(month||"");
  const [currentMonthName, setCurrentMonthName] = useState("");
  const [currentYear, setCurrentYear] = useState(year||"");
  const [selectedRows, setSelectedRows] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const permissions= JSON.parse(localStorage.getItem("perm"))||[]



  const selectLayoutState = (state) => state.Payroll;
  const payRollProperties = createSelector(selectLayoutState, (payroll) => ({
    paySlipList: payroll?.paySlipList,
    employeePaySlipDetails: payroll?.employeePaySlipDetails,
    paySlipHistory: payroll?.paySlipHistory,
    allPaySlipHistory: payroll?.allPaySlipHistory,
    responseJson: payroll?.responseJson,
  }));

  const { paySlipHistory, allPaySlipHistory } = useSelector(payRollProperties);

  const printRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "Summary Print Document",
  });

  const handleValidate = (ids) => {
    if (ids.length === 0) return;
    dispatch(validatePayslips(ids)).then(() => {
      dispatch(
        onLoadPaySlipHistory({
          month: currentMonth,
          year: currentYear,
        }),
      );
    });
  };

  const handleReject = (ids) => {
    if (ids.length === 0) return;
    dispatch(rejectPayslips(ids)).then(() => {
      dispatch(
        onLoadPaySlipHistory({
          month: currentMonth,
          year: currentYear,
        }),
      );
    });
  };

  useEffect(() => {
    //if (currentMonth && currentYear) {
      dispatch(
        onLoadPaySlipHistory({
          month: currentMonth,
          year: currentYear,
        }),
      );
      dispatch(
        onLoadAllPaySlipHistory({
          month: currentMonth,
          year: currentYear,
        }),
      );
    //}
  }, [currentMonth, currentYear]);

  const years = Array.from(
    { length: 5 },
    (_, i) => new Date().getFullYear() - i,
  );

  const months = [
    props.t("January"),
    props.t("February"),
    props.t("March"),
    props.t("April"),
    props.t("May"),
    props.t("June"),
    props.t("July"),
    props.t("August"),
    props.t("September"),
    props.t("October"),
    props.t("November"),
    props.t("December"),
  ];

  const Columns = [
    {
      header: props.t("No."),
      style: "button",
      enableColumnFilter: false,
      cell: (cell) => {
        return <div>{cell.row.index + 1}</div>;
      },
    },
    {
      header: props.t("name"),
      style: "button",
      enableColumnFilter: false,
      cell: (cell) => {
        return <div>{cell.row.original?.name}</div>;
      },
    },
    {
      header: props.t("basic_salary"),
      style: "button",
      enableColumnFilter: false,
      cell: (cell) => {
        return <div>{cell.row.original?.basicSalary}</div>;
      },
    },
    {
      header: props.t("total_bonus"),
      style: "button",
      enableColumnFilter: false,
      cell: (cell) => {
        return <div>{cell.row.original?.totalOfBonuses}</div>;
      },
    },
    {
      header: props.t("gross_salary"),
      style: "button",
      enableColumnFilter: false,
      cell: (cell) => {
        return <div>{cell.row.original?.grossSalary}</div>;
      },
    },
    {
      header: props.t("total_deduction"),
      style: "button",
      enableColumnFilter: false,
      cell: (cell) => {
        return <div>{cell.row.original?.totalDeductions}</div>;
      },
    },
    {
      header: props.t("Other_deductions"),
      style: "button",
      enableColumnFilter: false,
      cell: (cell) => {
        return <div>{cell.row.original?.totalOfRefunds}</div>;
      },
    },
    {
      header: props.t("net_salary"),
      style: "button",
      enableColumnFilter: false,
      cell: (cell) => {
        return <div>{cell.row.original?.netSalary}</div>;
      },
    },
    {
      header: props.t("status"),
      style: "button",
      enableColumnFilter: false,
      cell: (cell) => {
        return <div className={` rounded-1 text-center fw-semibold ${cell.row.original?.status==="APPROVED"?"bg-success":cell.row.original?.status==="REJECTED"?"bg-danger":cell.row.original?.status==="DRAFT"?"bg-warning": ""}`}>{cell.row.original?.status}</div>;
      },
    },
    {
      header: props.t("actions"),
      style: "button",
      enableColumnFilter: false,
      cell: (cell) => {
        return (
          <div>
            <Link
              to={`/payroll/paymaster/print`}
              className="text-dark d-inline-block edit-item-btn"
              style={{ fontSize: "15px" }}
              onClick={() => {
                selectedRows.pop();
                selectedRows.push(cell.row.original.id);
                console.log("selectd", selectedRows);
                localStorage.setItem(
                  "selectedPaySlips",
                  JSON.stringify(selectedRows),
                );
              }}>
              <i className="fa fa-eye" aria-hidden="true"></i>
            </Link>

            {
              permissions.includes("VALIDATE_SLIPS") && (
                <>
                  <Button
                    color="success"
                    className="ms-2"
                    onClick={() => handleValidate([cell.row.original.id])}
                  >
                    {props.t("Approve")}
                  </Button>
                  <Button
                    color="danger"
                    className="ms-2"
                    onClick={() => handleReject([cell.row.original.id])}
                  >
                    {props.t("Reject")}
                  </Button>
                </>
              )
            }
          </div>
        );
      },
    },
  ];

  return (
    <div className=" p-3">
      <h5 className=" fw-bold">{props.t("Pay_master")}</h5>
      {/* Date selector */}
      <div className=" d-flex py-2 justify-content-end">
        {/* year selector */}
        <select
          className="form-select w-25"
          aria-label="Default select example"
          value={currentYear}
          onChange={(value) => {
            console.log("year", value.target.value);
            setCurrentYear(value.target.value);
          }}>
          <option value={""}>{props.t("select_year")}</option>
          {years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>

        {/* month selector */}
        <select
          className="form-select w-25"
          aria-label="Default select example"
          value={currentMonth}
          onChange={(value) => {
            console.log("month", value.target.value);
            setCurrentMonth(value.target.value);
            setCurrentMonthName(months[value.target.value - 1]);
          }}>
          <option value={""}>{props.t("select_month")}</option>
          {months.map((month, index) => (
            <option key={month} value={index + 1}>
              {month}
            </option>
          ))}
        </select>
        {/* print controls */}
        <Button
          color="primary"
          className="ms-2"
          onClick={() => {
            console.log("selected Rows", selectedRows);
            localStorage.setItem(
              "selectedPaySlips",
              JSON.stringify(selectedRows),
            );
            navigation("/payroll/paymaster/print");
          }}
          disabled={selectedRows.length <= 1}>
          <i className="fa fa-eye text-white"></i>
          {props.t("view_pay_slips")}
        </Button>
        {
          permissions.includes("VALIDATE_SLIPS") && (
            <>
              <Button
                color="success"
                className="ms-2"
                disabled={selectedRows.length === 0}
                onClick={() => handleValidate(selectedRows)}
              >
                {props.t("Approve All")} ({selectedRows.length})
              </Button>
              <Button
                color="danger"
                className="ms-2"
                disabled={selectedRows.length === 0}
                onClick={() => handleReject(selectedRows)}
              >
                {props.t("Reject All")} ({selectedRows.length})
              </Button>
            </>
          )
        }

        <Button
          color="primary"
          className="ms-2"
          onClick={() => {
            handlePrint();
          }}>
          <i className="fa fa-print"></i>
          {props.t("print")}
        </Button>

        {/* payroll controls */}
        <Button
          color="primary"
          className=" ms-2"
          onClick={() => setIsOpen(!isOpen)}>
          <i className="fa fa-forward"></i>
          {props.t("run_payroll")}
        </Button>
      </div>
      <div>
        <TableContainer
          columns={Columns}
          data={paySlipHistory.items || []}
          tableTotalPage={paySlipHistory.total_page || 0}
          showPagination={true}
          customPageSize={paySlipHistory.size}
          tablePage={paySlipHistory.page}
          tableTotal={paySlipHistory.total_items}
          enableRowSelection={true}
          onSelectionChange={(rows) => {
            const data = rows.map((row) => row.id);
            setSelectedRows(data);
          }}
        />
      </div>
      <PrintReport
        printRef={printRef}
        props={props}
        currentMonth={currentMonthName}
        currentYear={currentYear}
		data={allPaySlipHistory || []}
      />
      <RunPayrollModal
        open={isOpen}
        handleOpen={setIsOpen}
        years={years}
        months={months}
        props={props}
      />
    </div>
  );
};

export default withRouter(withTranslation()(PayMaster));

const RunPayrollModal = ({ open, handleOpen, years, months, props }) => {
  const [currentMonth, setCurrentMonth] = useState("");
  const [currentYear, setCurrentYear] = useState("");

  const dispatch = useDispatch();
  const runPayroll = () => {
    dispatch(
      runPayRoll({
        year: currentYear,
        month: currentMonth,
      }),
    );
    handleOpen(false);
  };
  return (
    <Modal isOpen={open}>
      <ModalHeader
        toggle={() => {
          handleOpen(!open);
        }}>
        Run Payroll
      </ModalHeader>
      <ModalBody>
        <div className=" d-flex w-100 gap-2">
          {/* year selector */}
          <select
            className="form-select flex-grow-1"
            aria-label="Default select example"
            value={currentYear}
            onChange={(value) => {
              console.log("year", value.target.value);
              setCurrentYear(value.target.value);
            }}>
            <option value={""}>{props.t("select_year")}</option>
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>

          {/* month selector */}
          <select
            className="form-select flex-grow-1"
            aria-label="Default select example"
            value={currentMonth}
            onChange={(value) => {
              console.log("month", value.target.value);
              setCurrentMonth(value.target.value);
            }}>
            <option value={""}>{props.t("select_month")}</option>
            {months.map((month, index) => (
              <option key={month} value={index + 1}>
                {month}
              </option>
            ))}
          </select>
        </div>

        <Button
          color="primary"
          className="w-100 mt-3"
          onClick={() => {
            console.log("running payroll for", currentMonth, currentYear);
            runPayroll();
          }}>
          <i className="fa fa-forward"></i>
          {props.t("run_payroll")}
        </Button>
      </ModalBody>
    </Modal>
  );
};

const PrintReport = ({ printRef, props, currentMonth, currentYear, data }) => {
  const columns = [
    {
      header: props.t("SN"),
      cell: (cell) => <div>{cell.row.index + 1}</div>,
    },
    {
      header: props.t("name"),
      cell: (cell) => <div>{cell.row.original.name}</div>,
    },
    {
      header: props.t("basic_salary"),
      cell: (cell) => <div>{cell.row.original.basicSalary}</div>,
    },
    {
      header: `${props.t("gross_salary")}(${props.t("basic")} + ${props.t("bonuses")})`,
      cell: (cell) => <div>{cell.row.original.grossSalary}</div>,
    },
    {
      header: props.t("taxable"),
      cell: (cell) => (
        <div>
          {cell.row.original.taxable ?
            <Badge color="success">{props.t("yes")}</Badge>
          : <Badge color="danger">{props.t("no")}</Badge>}
        </div>
      ),
    },
    {
      header: props.t("Other_deductions"),
      cell: (cell) => <div>{cell.row.original.totalOfRefunds}</div>,
    },
    {
      header: props.t("total_deductions"),
      cell: (cell) => <div>{cell.row.original.totalDeductions}</div>,
    },
    {
      header: props.t("total_bonuses"),
      cell: (cell) => <div>{cell.row.original.totalOfBonuses}</div>,
    },
    {
      header: props.t("net_salary"),
      cell: (cell) => <div>{cell.row.original.netSalary}</div>,
    },
    {
      header: props.t("date"),
      cell: (cell) => <div>{cell.row.original.payDate}</div>,
    },
  ];

  return (
    <div ref={printRef} className=" d-none d-print-block px-2">
      <PrintHeader />
      <h4 className="text-center">
        Salary Summary report for {currentMonth}{" "}
        {currentYear || new Date().getFullYear()}{" "}
      </h4>
      <TableContainer
        columns={columns}
        data={data}
		customPageSize={data.length}
        showPagination={false}
        style={{ minHeight: "400px" }}
      />
      {/*<div className=" d-flex">
        <p
          className=" py-2 border-1 border  px-2 fs-5 fw-bold "
          style={{ minWidth: "160px" }}>
          {props.t("total")}
        </p>
        <p className=" py-2 border-1 border flex-grow-1  px-2 fs-5">00 XAF</p>
      </div>*/}
    </div>
  );
};
